import { useHistory } from 'react-router-dom'
import LoggerService from '../services/logger.service'
import { AppRouterConstants } from '../components/appRouter/AppRouter.constants'

export const navigateToCrew = () => {
  navigateTo(AppRouterConstants.CREW_ROUTE)
}

let routerHistory: any = null

export const setRouterHistory = (history: History) => {
  routerHistory = history
}

export const getRouterHistory = () => {
  return routerHistory
}

export const navigateTo = (path: string) => {
  if (routerHistory) {
    try {
      routerHistory.push(path)
    } catch (error) {
      LoggerService.error(`Navigation error: ${error}`)
      window.location.href = path
    }
  } else {
    LoggerService.warn('Router history not initialized, using window.location')
    window.location.href = path
  }
}

export const navigateReplace = (path: string) => {
  if (routerHistory) {
    try {
      routerHistory.replace(path)
    } catch (error) {
      LoggerService.error(`Navigation error: ${error}`)
      window.location.href = path
    }
  } else {
    LoggerService.warn('Router history not initialized, using window.location')
    window.location.href = path
  }
}

export const goBack = () => window.history.back()
export const goBackTo = (steps: number) => window.history.go(-steps)

export const getRouteOrigin = (): string | undefined =>
  (getRouterHistory()?.location?.state as { from?: string } | undefined)?.from

export const useGoBack = () => {
  const history = useHistory()
  return () => {
    try {
      history.back()
    } catch (error) {
      LoggerService.error(`Navigation error: ${error}`)
      window.history.back()
    }
  }
}
